import React from 'react';
import PropTypes from 'prop-types';

import Slider from 'components/slider';
import { formatNumberWithIntl } from 'utils';

const propTypes = {
  label: PropTypes.string,
  sliderValue: PropTypes.number,
  percentile90: PropTypes.number,
  onSalaryChange: PropTypes.func,
};

const defaultProps = {
  label: 'Min',
  sliderValue: 0,
  percentile10: 0,
  percentile90: 200000,
  onSalaryChange: () => {},
};

const KEYCODE = {
  ARROW_UP: 38,
  ARROW_DOWN: 40,
};

const MAX_VALUE = 10_000_000;

const FORMAT_OPTIONS = {
  maximumSignificantDigits: 7,
};

const SalaryFilter = ({ sliderValue, label, isHourly, percentile10, percentile90, onSalaryChange }) => {
  const salary = isHourly ? sliderValue : formatNumberWithIntl(sliderValue, FORMAT_OPTIONS);

  const maxSalary = isHourly ? parseFloat(percentile90 / 2080) : percentile90;

  const minSalary = isHourly ? parseFloat(percentile10 / 2080) : percentile10;

  const handleSliderChange = (value) => {
    const newValue = value > maxSalary ? maxSalary : value;
    onSalaryChange(isHourly ? parseFloat(newValue).toFixed(2) : newValue);
  };

  const handleInputChange = (e) => {
    let newSalary = parseFloat(e.target.value.replace(/\D/g, ''));

    if (newSalary >= MAX_VALUE) return;

    if (newSalary > maxSalary) newSalary = maxSalary;

    if (isNaN(newSalary)) {
      return onSalaryChange(0);
    }

    onSalaryChange(newSalary);
  };

  const handleKeyDown = (e) => {
    switch (e.keyCode) {
      case KEYCODE.ARROW_UP:
        onSalaryChange(sliderValue + (isHourly ? 0.01 : 1));
        break;
      case KEYCODE.ARROW_DOWN:
        if (e.keyCode === 40 && sliderValue !== 0) {
          onSalaryChange(sliderValue - (isHourly ? 0.01 : 1));
        }
        break;
      default:
        break;
    }
  };

  return (
    <div className="salary-filter-container">
      <label htmlFor="salary-input" className="input-label">
        {label}
      </label>

      <div className="d-flex mt-1">
        <input value="$" disabled className="d-inline form-control salary-filter-input-prefix" />
        <input
          value={salary}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          className="d-inline form-control filter-input salary-input"
        />
      </div>

      <div className="salary-slider">
        <Slider
          className="z-mt-32"
          min={minSalary}
          max={Math.max(maxSalary, sliderValue)}
          value={[sliderValue]}
          step={isHourly ? 0.01 : 1}
          onValueChange={handleSliderChange}
        />
      </div>
    </div>
  );
};

SalaryFilter.propTypes = propTypes;
SalaryFilter.defaultProps = defaultProps;

export default SalaryFilter;
